import ko from 'knockout';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const {
  IsCallMeteringInAUAllowed,
} = config.get('Permissions') || {};
const countyCodeForAU = 'AU';

export default class {
  constructor({
    CallFees,
    AllowedCountries,
    CountryCode,
    IsCallTrackingEnabled,
  }) {
    this.countryCallTrackingSupported = ko.computed(() => {
      if (CallFees && AllowedCountries) {
        return _.contains(AllowedCountries, ko.unwrap(CountryCode));
      }

      return true;
    });

    this.disableCallTracking = ko.computed(() => {
      if (ko.unwrap(CountryCode) === countyCodeForAU && !IsCallMeteringInAUAllowed) {
        return true;
      }
      return !this.countryCallTrackingSupported();
    });

    this.IsCallTrackingEnabled = IsCallTrackingEnabled;
    this.stringIsCallTrackingEnabled = ko.computed({
      read: () => {
        IsCallTrackingEnabled(!this.disableCallTracking() && IsCallTrackingEnabled()); // eslint-disable-line

        return IsCallTrackingEnabled.string();
      },
      write: (newValue) => {
        IsCallTrackingEnabled.string(newValue);
      },
    });

    return this;
  }
}
